import axios from 'axios'
import { StorageService } from '../services/storage.service'
import store from '../store/index'

class ApiError extends Error {
  constructor (errorType, errorCode, message) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    this.errorType = errorType
    this.errorCode = errorCode
  }
}

const ApiService = {
  _401interceptor: null,
  _reqInterceptor: null,

  init (baseURL) {
    axios.defaults.baseURL = baseURL
  },

  setHeader () {
    const data = StorageService.getAuthdata()
    axios.defaults.headers.common.Authorization = `Bearer ${data.token}`
    // axios.defaults.headers.common['App-Source'] = process.env.VUE_APP_APPSOURCE
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    axios.defaults.headers.common.Accept = 'application/json'
  },

  removeHeader () {
    axios.defaults.headers.common = {}
  },

  get (resource) {
    return axios.get(resource)
  },

  post (resource, data, config) {
    return axios.post(resource, data, config)
  },

  put (resource, data) {
    return axios.put(resource, data)
  },

  delete (resource) {
    return axios.delete(resource)
  },

  async customRequest (data) {
    await this.setHeader()
    return axios(data)
  },

  async customDefault (data) {
    return axios(data)
  },

  mount401Interceptor () {
    if (process.env.NODE_ENV === 'development') {
      this._reqInterceptor = axios.interceptors.request.use(config => {
        return config
      }, error => {
        return Promise.reject(error)
      })
    }

    this._401interceptor = axios.interceptors.response.use(
      (response) => {
        return response
      },
      error => {
        if (error.response && error.response.status === 401) {
          store.dispatch('auth/forceLogout')
          throw error
        }

        throw error
      }
    )
  },

  unmount401Interceptor () {
    // Eject the interceptor
    axios.interceptors.response.eject(this._401interceptor)
    axios.interceptors.response.eject(this._reqInterceptor)
  },

  handleError (error) {
    if (error.request.status > 0) {
      const response = JSON.parse(error.request.response)
      throw new ApiError('warning', response.status, response.message)
    } else {
      throw new ApiError('error', error.status, error.message)
    }
  }
}

export default ApiService
export { ApiService, ApiError }
